import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { COMPANY, NAV_LINKS } from "@/lib/company";

const linkBase =
  "px-3 py-2 text-sm font-medium transition-colors border-b-2 border-transparent";

export const Header = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-slate-200 shadow-sm" data-testid="site-header">
      <div className="bg-slate-900 text-slate-300 text-xs">
        <div className="mx-auto max-w-7xl px-4 py-2 flex items-center justify-between gap-4">
          <span className="truncate">{COMPANY.address_line1}, {COMPANY.address_line2}</span>
          <div className="flex items-center gap-4 shrink-0">
            <a href={`tel:${COMPANY.phoneHref}`} className="hover:text-white flex items-center gap-1.5" data-testid="topbar-phone">
              <Phone className="h-3.5 w-3.5" /> {COMPANY.phone}
            </a>
            <a href={`mailto:${COMPANY.email}`} className="hover:text-white hidden sm:inline" data-testid="topbar-email">
              {COMPANY.email}
            </a>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-4">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex flex-col leading-none" data-testid="brand-link">
            <span className="text-lg sm:text-xl font-extrabold tracking-tight text-slate-900">
              ANDR BNDT88 <span className="text-blue-800">TRANS LLC</span>
            </span>
            <span className="text-[11px] uppercase tracking-wider text-slate-500 mt-1">
              {COMPANY.tagline}
            </span>
          </Link>

          <nav className="hidden lg:flex items-center" data-testid="desktop-nav">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.path}
                to={l.path}
                end={l.path === "/"}
                data-testid={`nav-${l.path === "/" ? "home" : l.path.slice(1)}-link`}
                className={({ isActive }) =>
                  `${linkBase} ${isActive ? "text-blue-800 border-blue-800" : "text-slate-700 hover:text-blue-800"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <button
              onClick={() => navigate("/contact?type=Transportation%20Quote")}
              data-testid="nav-quote-btn"
              className="ml-4 inline-flex items-center rounded-md bg-blue-800 px-4 py-2.5 text-sm font-semibold text-white hover:bg-blue-900 transition-colors"
            >
              Request a Transport Quote
            </button>
          </nav>

          <button
            className="lg:hidden p-2 text-slate-700"
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white" data-testid="mobile-nav">
          <div className="px-4 py-3 space-y-1">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.path}
                to={l.path}
                end={l.path === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `block px-3 py-2.5 rounded-md text-sm font-medium ${
                    isActive ? "bg-blue-50 text-blue-800" : "text-slate-700 hover:bg-slate-50"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <button
              onClick={() => { setOpen(false); navigate("/contact?type=Transportation%20Quote"); }}
              className="w-full mt-2 rounded-md bg-blue-800 px-4 py-3 text-sm font-semibold text-white"
              data-testid="mobile-quote-btn"
            >
              Request a Transport Quote
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
